import {activateCurrentUserManagementUser} from "@project/sdk/user-management";
import {ActivateCurrentUserManagementUserResponse} from "@project/sdk/user-management/zod";
import {mutationOptions} from "@tanstack/react-query";
import {
  userManagementUserKeys,
  userManagementUserMutationKeys,
} from "../../../userManagementUser-keys";

export function activateCurrentUserManagementUserMutationOptions() {
  return mutationOptions({
    mutationKey: userManagementUserMutationKeys.activateCurrentUserManagementUser,
    mutationFn: async () =>
      ActivateCurrentUserManagementUserResponse.parse(await activateCurrentUserManagementUser()),
    retry: 2,
    onSuccess: async (_data, _variables, _context, {client}) => {
      await client.invalidateQueries({queryKey: userManagementUserKeys.all});
    },
  });
}
